// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"76":"editnotes","526":"newentry","548":"calendar","571":"settings","644":"editjournalentry"}[chunkId] + "." + {"76":"8196a8a7","526":"dc562261","548":"ead66c3e","571":"b1f5d135","644":"dc562261"}[chunkId] + ".css";
};